/** RouteError and NotFound: honest failures inside the shell, each with its way out. */
import { useRouteError } from "react-router-dom";
import { Button, Card, CardBody, EmptyState, PageHeading } from "../kit";
import { href } from "./links";

export function RouteError() {
  const error = useRouteError();
  const chunk = error instanceof Error && /dynamically imported module|Failed to fetch/i.test(error.message);
  return (
    <div className="flex w-full flex-col gap-7">
      <PageHeading title="Something broke" />
      <Card className="w-full">
        <CardBody>
          <EmptyState role="alert" icon="feed-alert" title={chunk ? "This screen didn't load" : "This screen hit an error"} hint={chunk ? "A newer version may be out." : undefined}>
            <Button variant="primary" size="sm" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </EmptyState>
        </CardBody>
      </Card>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="flex w-full flex-col gap-7">
      <PageHeading title="Not found" />
      <Card className="w-full">
        <CardBody>
          <EmptyState title="Nothing lives at this address">
            <Button asChild variant="surface" size="sm">
              <a href={href("/")}>Go to Today</a>
            </Button>
          </EmptyState>
        </CardBody>
      </Card>
    </div>
  );
}
